export const Danger = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <circle cx="8" cy="8" r="8" fill="#FF0000"/>
    <path d="M8 4L8 9.23077" stroke="white" strokeWidth="1.68103" strokeLinecap="round"/>
    <path d="M8 12.1731L8 12.5" stroke="white" strokeWidth="1.68103" strokeLinecap="round"/>
  </svg>
);
